import { ApiOutlined } from '@ant-design/icons';
import {
  Button,
  type ButtonProps,
  Popconfirm,
  type PopconfirmProps,
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ButtonType } from 'antd/es/button';
import type { SizeType } from 'antd/es/config-provider/SizeContext';

type TAssignButtonProps = {
  testId?: string;
  className?: string;
  onClick?: () => void;
  disabled: boolean;
  loading: boolean;
  icon?: ButtonProps['icon'];
  size?: SizeType;
  type?: ButtonType;
  behavior: {
    confirm: string;
    isAssigned: () => boolean;
  };
  placement?: PopconfirmProps['placement'];
};

export const AssignButton: React.FC<TAssignButtonProps> = (props) => {
  const { t } = useTranslation();
  const {
    testId,
    loading,
    className,
    disabled,
    icon = <ApiOutlined />,
    onClick,
    size = 'small',
    behavior,
    placement = 'topLeft',
  } = props;

  const [assigned, setAssigned] = React.useState(
    Boolean(behavior.isAssigned()),
  );

  return (
    <Button
      loading={loading}
      icon={icon}
      data-testid={testId}
      size={size}
      className={className}
      type={assigned ? 'link' : 'default'}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();

        if (assigned) {
          // Do nothing - handle in the popconfirm.
        } else {
          onClick?.();
          setAssigned(true);
        }
      }}
    >
      {assigned ? (
        <Popconfirm
          title={behavior.confirm}
          disabled={disabled}
          placement={placement}
          onConfirm={() => {
            onClick?.();
            setAssigned(false);
          }}
        >
          {t('actions.unAssign')}
        </Popconfirm>
      ) : (
        t('actions.assign')
      )}
    </Button>
  );
};
